// import axios from 'axios'
const axios = window.axios

//配置全局数据请求类型
// axios.defaults.headers['Content-Type'] = "application/json;charset=utf-8";

const http = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? 'https://pc.tongctec.com'
      : 'https://pc.tongctec.com'
})
// http.defaults.headers.common['Authorization'] = AUTH_TOKEN;
http.interceptors.request.use(
  config => {
      //数据转换
      // config.data = 'object'===typeof config.data ? JSON.stringify(config.data) : config.data;
      //追加访问令牌
      // let token = localStorage.getItem('token') || ''
      // config.headers.Authorization = token
    return config
  },
  err => Promise.resolve(err)
)
http.interceptors.response.use(
  res=>{
      if(res.status === 200){
          return res['data'];
      }
      return Promise.reject(res);
  },
  err => Promise.resolve(err)
)

export default http
